import { render, staticRenderFns } from "./ClienteProveedorForm.vue?vue&type=template&id=cdcc98be&"
import script from "./ClienteProveedorForm.vue?vue&type=script&lang=ts&"
export * from "./ClienteProveedorForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports